import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheLoneExplorersView from "./sections/TheLoneExplorersView";
import ElevatingDigitalIdentity from "./sections/ElevatingDigitalIdentity";
import SolutionEcosystem from "./sections/SolutionEcosystem";
import TheSocialReel from "./sections/TheSocialReel";
import DynamicHomepage from "./sections/DynamicHomepage";
import ThePortfolioShowcase from "./sections/ThePortfolioShowcase";
import ClientAccolades from "./sections/ClientAccolades";
import StartAConversation from "./sections/StartAConversation";
import PulseMetricsFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheLoneExplorersView />
      <ElevatingDigitalIdentity />
      <TheSocialReel />
      <SolutionEcosystem />
      <DynamicHomepage />
      <ThePortfolioShowcase />
      <ClientAccolades />
      <StartAConversation />
      <PulseMetricsFooter />
    </div>;
}